import { gql } from '@apollo/client'

export const SHOPIFY_STOREFRONT_API_VERSION = '2024-04'

export const CREATE_CART = gql`
  mutation cartCreate($input: CartInput!) {
    cartCreate(input: $input) {
      userErrors {
        message
        field
      }
      cart {
        id
        checkoutUrl
        cost {
          totalTaxAmount {
            amount
            currencyCode
          }
          totalAmount {
            amount
            currencyCode
          }
          subtotalAmount {
            amount
            currencyCode
          }
        }
        lines(first: 250) {
          edges {
            node {
              quantity
              merchandise {
                ... on ProductVariant {
                  id
                  title
                  sku
                  distributorSku: sku
                  product {
                    title
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`

// This has not been updated to the new storefront cart API. I believe we don't use it anymore.
export const APPLY_DISCOUNT_CODE_TO_CHECKOUT = gql`
  mutation applyDiscountCodeToCheckout($checkoutId: ID!, $discountCode: String!) {
    checkoutDiscountCodeApplyV2(checkoutId: $checkoutId, discountCode: $discountCode) {
      checkout {
        discountApplications(first: 10) {
          edges {
            node {
              allocationMethod
              targetSelection
              targetType
            }
          }
        }
      }
      userErrors {
        message
        code
      }
    }
  }
`
